import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ADMIN_API } from "../../common/common";
import { Logout } from "../../common/Funcation";
import { notifyError, notifyMessage, postApi } from "../../service";
import SkyPopup from "../../components/SkyPopup";
import Loader from "../../components/Loader";
import moment from "moment";

interface ActiveStatus {
  bookmaker: boolean;
  fancy: boolean;
  premium: boolean;
  status: boolean;
}

interface Suspend {
  bookmaker: boolean;
  fancy: boolean;
  premium: boolean;
  odds: boolean;
}

interface Limit {
  min: number;
  max: number;
  maxProfit?: number;
  betDelay?: number;
  maxPrice?: number;
  isShow?: boolean;
}

interface ProfitLimits {
  odds: number;
  bookmaker: number;
  fancy: number;
  premium: number;
}
interface MatchItem {
  _id: string;
  name: string;
  openDate: string;
  startDate: string;
  gameId: number;
  marketId: string;
  type: string;
  status: boolean;
  winner: string;
  winnerSelection: string[];
  activeStatus: ActiveStatus;
  suspend: Suspend;
  oddsLimit: Limit;
  bet_odds_limit: Limit;
  bet_bookmaker_limit: Limit;
  bet_fancy_limit: Limit;
  bet_premium_limit: Limit;
  max_profit_limit?: ProfitLimits;
}

interface PageData {
  results?: MatchItem[];
  page?: string;
  limit?: string;
  totalPages?: number;
  totalResults?: number;
  scope?: "platform" | "subowner" | "website";
}

function SportsSettings() {
  const navigate = useNavigate();
  const DD = useSelector((e: any) => e.domainDetails);

  const [tab, setTab] = useState<string>("cricket");
  const [pageData, setPageData] = useState<MatchItem[]>([]);
  const [isLoader, setIsLoader] = useState<boolean>(false);

  // Modal / Popup controls
  const [activeModal, setActiveModal] = useState<"limit" | "bookmaker" | "manipulation" | "scw" | "winner" | null>(null);
  const [selectedItem, setSelectedItem] = useState<MatchItem | null>(null);

  // Odds Limit form state
  const [oddsLimit, setOddsLimit] = useState({ min: 0, max: 0 });
  const [betOddsLimit, setBetOddsLimit] = useState({ min: 0, max: 0, maxProfit: 0, betDelay: 0 });

  // Bookmaker form state
  const [bookmakerActive, setBookmakerActive] = useState<boolean>(true);
  const [bookmakerSuspend, setBookmakerSuspend] = useState<boolean>(false);
  const [betBookmakerLimit, setBetBookmakerLimit] = useState({ min: 0, max: 0, maxProfit: 0, betDelay: 0 });

  // Manipulation form state
  const [activeStatus, setActiveStatus] = useState<ActiveStatus>({
    status: true,
    fancy: true,
    premium: true,
    bookmaker: true,
  });
  const [suspend, setSuspend] = useState<Suspend>({
    odds: false,
    fancy: false,
    premium: false,
    bookmaker: false,
  });

  // SCW form state
  const [betFancyLimit, setBetFancyLimit] = useState({ min: 0, max: 0, maxProfit: 0, betDelay: 0 });
  const [betPremiumLimit, setBetPremiumLimit] = useState({ min: 0, max: 0, maxProfit: 0, betDelay: 0 });
  const [maxProfitLimit, setMaxProfitLimit] = useState<ProfitLimits>({ odds: 0, bookmaker: 0, fancy: 0, premium: 0 });

  // Winner Declare form state
  const [winner, setWinner] = useState<string>("");
  const [winnerOptions, setWinnerOptions] = useState<string[]>([]);

  useEffect(() => {
    fetchMatches(tab);
  }, [tab]);

  const fetchMatches = async (sportType: string) => {
    setIsLoader(true);
    let data = {
      api: ADMIN_API.SETTING.SPORT_MARKET.GET_NEXT_2DAYS_SPORTS_LIST,
      value: {
        type: sportType,
      },
    };
    await postApi(data)
      .then((response) => {
        setPageData(response.data.data || []);
        setIsLoader(false);
      })
      .catch((err) => {
        setIsLoader(false);
        if (err.response?.data?.statusCode === 401) {
          Logout();
          navigate("/login");
        } else {
          notifyError(err.response?.data?.message || "Failed to fetch matches");
        }
      });
  };
console.log({pageData})
  const handleTabChange = (sportType: string) => {
    setTab(sportType);
  };


  const openEditModal = (modalType: "limit" | "bookmaker" | "manipulation" | "scw" | "winner", item: MatchItem) => {
    setSelectedItem(item);
    setActiveModal(modalType);

    if (modalType === "limit") {
      setOddsLimit({
        min: item.oddsLimit?.min || 0,
        max: item.oddsLimit?.max || 0,
      });
      setBetOddsLimit({
        min: item.bet_odds_limit?.min || 0,
        max: item.bet_odds_limit?.max || 0,
        maxProfit: item.bet_odds_limit?.maxProfit || 0,
        betDelay: item.bet_odds_limit?.betDelay || 0,
      });
    } else if (modalType === "bookmaker") {
      setBookmakerActive(item.activeStatus?.bookmaker ?? true);
      setBookmakerSuspend(item.suspend?.bookmaker ?? false);
      setBetBookmakerLimit({
        min: item.bet_bookmaker_limit?.min || 0,
        max: item.bet_bookmaker_limit?.max || 0,
        maxProfit: item.bet_bookmaker_limit?.maxProfit || 0,
        betDelay: item.bet_bookmaker_limit?.betDelay || 0,
      });
    } else if (modalType === "manipulation") {
      setActiveStatus({
        status: item.activeStatus?.status ?? true,
        fancy: item.activeStatus?.fancy ?? true,
        premium: item.activeStatus?.premium ?? true,
        bookmaker: item.activeStatus?.bookmaker ?? true,
      });
      setSuspend({
        odds: item.suspend?.odds ?? false,
        fancy: item.suspend?.fancy ?? false,
        premium: item.suspend?.premium ?? false,
        bookmaker: item.suspend?.bookmaker ?? false,
      });
    } else if (modalType === "scw") {
      setBetFancyLimit({
        min: item.bet_fancy_limit?.min || 0,
        max: item.bet_fancy_limit?.max || 0,
        maxProfit: item.bet_fancy_limit?.maxProfit || 0,
        betDelay: item.bet_fancy_limit?.betDelay || 0,
      });
      setBetPremiumLimit({
        min: item.bet_premium_limit?.min || 0,
        max: item.bet_premium_limit?.max || 0,
        maxProfit: item.bet_premium_limit?.maxProfit || 0,
        betDelay: item.bet_premium_limit?.betDelay || 0,
      });
      setMaxProfitLimit({
        odds: item.max_profit_limit?.odds || 0,
        bookmaker: item.max_profit_limit?.bookmaker || 0,
        fancy: item.max_profit_limit?.fancy || 0,
        premium: item.max_profit_limit?.premium || 0,
      });
    } else if (modalType === "winner") {
      setWinner(item.winner || "");
      let options = item.winnerSelection && item.winnerSelection.length > 0
        ? item.winnerSelection
        : (item.name ? item.name.split(" v ") : []);
      setWinnerOptions(options);
    }
  };


  const updateLocalMatch = (matchId: string, updates: Partial<MatchItem>) => {
    setPageData((prev) => prev.map((item) =>
      item._id === matchId ? { ...item, ...updates } : item
    ));
  };

  const handleModalSubmit = async (e: any) => {
    e.preventDefault();
    if (!selectedItem) return;

    setIsLoader(true);

    try {
      // 1. Ensure the match is activated in the sports collection first if status is false.
      if (!selectedItem.status) {
        let activeData = {
          api: ADMIN_API.SPORTS.ACTIVE_SPORT, // sports/activeSport
          value: {
            id: selectedItem._id,
            type: tab,
          },
        };
        await postApi(activeData);
      }

      // 2. Perform the update based on current active modal type.
      if (activeModal === "winner") {
        let declareData = {
          api: ADMIN_API.SETTING.SPORT_MARKET.DECLARE_WINNER, // sports/declareWinner
          value: {
            id: selectedItem._id,
            winner: winner,
          },
        };
        await postApi(declareData).then((response) => {
          notifyMessage(response.data.message || "Winner declared successfully!");
          updateLocalMatch(selectedItem._id, { winner });
        });
      } else {
        // Construct standard update payloads
        let updatedActiveStatus = { ...(selectedItem.activeStatus || { status: true, bookmaker: true, fancy: true, premium: true }) };
        let updatedSuspend = { ...(selectedItem.suspend || { odds: false, bookmaker: false, fancy: false, premium: false }) };
        let updatedOddsLimit = { ...(selectedItem.oddsLimit || { min: 0, max: 0 }) };
        let updatedBetOddsLimit = { ...(selectedItem.bet_odds_limit || { min: 0, max: 0 }) };
        let updatedBetBookmakerLimit = { ...(selectedItem.bet_bookmaker_limit || { min: 0, max: 0 }) };
        let updatedBetFancyLimit = { ...(selectedItem.bet_fancy_limit || { min: 0, max: 0 }) };
        let updatedBetPremiumLimit = { ...(selectedItem.bet_premium_limit || { min: 0, max: 0 }) };

        if (activeModal === "limit") {
          updatedOddsLimit = { ...updatedOddsLimit, ...oddsLimit };
          updatedBetOddsLimit = { ...updatedBetOddsLimit, ...betOddsLimit };
        } else if (activeModal === "bookmaker") {
          updatedActiveStatus.bookmaker = bookmakerActive;
          updatedSuspend.bookmaker = bookmakerSuspend;
          updatedBetBookmakerLimit = { ...updatedBetBookmakerLimit, ...betBookmakerLimit };
        } else if (activeModal === "manipulation") {
          updatedActiveStatus = { ...updatedActiveStatus, ...activeStatus };
          updatedSuspend = { ...updatedSuspend, ...suspend };
        } else if (activeModal === "scw") {
          updatedBetFancyLimit = { ...updatedBetFancyLimit, ...betFancyLimit };
          updatedBetPremiumLimit = { ...updatedBetPremiumLimit, ...betPremiumLimit };
        }

        let updateData = {
          api: ADMIN_API.SETTING.SPORT_MARKET.UPDATE, // sports/updare
          value: {
            id: selectedItem._id,
            activeStatus: updatedActiveStatus,
            oddsLimit: updatedOddsLimit,
            bet_odds_limit: updatedBetOddsLimit,
            bet_bookmaker_limit: updatedBetBookmakerLimit,
            bet_fancy_limit: updatedBetFancyLimit,
            bet_premium_limit: updatedBetPremiumLimit,
            suspend: updatedSuspend,
            startDate: selectedItem.startDate,
          },
        };

        const updateResponse = await postApi(updateData);

        if (activeModal === "scw") {
          let profitData = {
            api: ADMIN_API.SETTING.SPORT_MARKET.UPDATE_PROFIT_LIMIT, // sports/updateProfitLimit
            value: {
              id: selectedItem._id,
              max_profit_limit: maxProfitLimit,
            },
          };
          await postApi(profitData);
          updateLocalMatch(selectedItem._id, { max_profit_limit: maxProfitLimit });
        }

        notifyMessage(updateResponse?.data?.message || "Settings updated successfully!");

        if (activeModal === "limit") {
          updateLocalMatch(selectedItem._id, {
            oddsLimit: updatedOddsLimit,
            bet_odds_limit: updatedBetOddsLimit,
          });
        } else if (activeModal === "bookmaker") {
          updateLocalMatch(selectedItem._id, {
            activeStatus: updatedActiveStatus,
            suspend: updatedSuspend,
            bet_bookmaker_limit: updatedBetBookmakerLimit,
          });
        } else if (activeModal === "manipulation") {
          updateLocalMatch(selectedItem._id, {
            activeStatus: updatedActiveStatus,
            suspend: updatedSuspend,
          });
        } else if (activeModal === "scw") {
          updateLocalMatch(selectedItem._id, {
            bet_fancy_limit: updatedBetFancyLimit,
            bet_premium_limit: updatedBetPremiumLimit,
          });
        }
      }

      setActiveModal(null);
      setSelectedItem(null);
      fetchMatches(tab);
    } catch (err: any) {
      setIsLoader(false);
      notifyError(err.response?.data?.message || "Failed to save settings");
    }
  };

  const getModalTitle = () => {
    if (!selectedItem) return "";
    switch (activeModal) {
      case "limit":
        return `Set Match Odds Limits - ${selectedItem.name}`;
      case "bookmaker":
        return `Set Bookmaker Limits - ${selectedItem.name}`;
      case "manipulation":
        return `Manipulate Status Switches - ${selectedItem.name}`;
      case "scw":
        return `Set S.C.W (Session & Premium) Limits - ${selectedItem.name}`;
      case "winner":
        return `Declare Outright Winner - ${selectedItem.name}`;
      default:
        return "";
    }
  };

  return (
    <div className="container main_wrap sport-settings-page">
      <style>{`
        .sport-settings-page .settings-table tbody td {
          font-size: 12px !important;
          line-height: 26px !important;
          color: #1e1e1e !important;
        }
        .sport-settings-page .action-btn-group .orange-btn {
          width: 120px !important;
          box-shadow: none !important;
          background-color: rgb(255, 184, 12) !important;
          color: rgb(0, 0, 0) !important;
          border: 1px solid #000 !important;
          padding: 0px !important;
          font-size: 11px !important;
          line-height: 23px !important;
          height: fit-content !important;
          font-weight: bold !important;
          border-radius: 4px !important;
        }
      `}</style>
      {isLoader && <Loader />}
      <div className="top_header">
        <div className="top_header_title">
          <h5>Sport Settings</h5>
        </div>
      </div>

      {/* Tabs */}
      <div className="sport-tabs">
        <button
          className="sport-tab-btn"
          onClick={() => handleTabChange("cricket")}
          style={{
            width: "95px",
            boxShadow: "none",
            backgroundColor: "rgb(255, 184, 12)",
            color: "#000",
            border: tab === "cricket" ? "1px solid #000" : "1px solid #bbb",
            paddingLeft: 0,
            paddingRight: 0,
            fontSize: "11px",
            lineHeight: "23px",
            height: "fit-content",
            padding: "0px",
            fontWeight: "bold",
            fontFamily: "Tahoma"
          }}
        >
          Cricket
        </button>
        <button
          className="sport-tab-btn"
          onClick={() => handleTabChange("tennis")}
          style={{
            width: "95px",
            boxShadow: "none",
            backgroundColor: "rgb(255, 184, 12)",
            color: "#000",
            border: tab === "tennis" ? "1px solid #000" : "1px solid #bbb",
           paddingLeft: 0,
            paddingRight: 0,
            fontSize: "11px",
            lineHeight: "23px",
            height: "fit-content",
            padding: "0px",
            fontWeight: "bold",
            fontFamily: "Tahoma"
          }}
        >
          Tennis
        </button>
        <button
          className="sport-tab-btn"
          onClick={() => handleTabChange("soccer")}
          style={{
            width: "95px",
            boxShadow: "none",
            backgroundColor: "rgb(255, 184, 12)",
            color: "#000",
            border: tab === "soccer" ? "1px solid #000" : "1px solid #bbb",
            paddingLeft: 0,
            paddingRight: 0,
            fontSize: "11px",
            lineHeight: "23px",
            height: "fit-content",
            padding: "0px",
            fontWeight: "bold",
            fontFamily: "Tahoma"
          }}
        >
          Soccer
        </button>
      </div>

      {/* Table List */}
      {!isLoader && (
        <div className="settings-table-container">
        <table className="settings-table">
          <thead>
            <tr>
              <th style={{width: "5%" }}>S No</th>
              <th style={{width: "10%" }}>Match ID</th>
              <th style={{width: "10%", textAlign: "right" }}>Match Name</th>
              <th style={{width: "10%", textAlign: "right" }}>Market ID</th>
              <th style={{width: "10%", textAlign: "right" }}>Cup Winner</th>
              <th style={{width: "10%", textAlign: "right" }}>Open Date</th>
              <th style={{width: "15%", textAlign: "right" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {pageData && pageData.length > 0 ? (
              pageData.map((item: MatchItem, index: number) => {
                const isOutright = !item.name.toLowerCase().includes(" v ");
                return (
                  <tr key={item._id || index}>
                    <td style={{ width: "5%", fontSize: "12px", lineHeight: "15px", color: "#1e1e1e", borderBottom: "1px solid #eef2f5" }}>{index + 1}</td>
                    <td style={{ fontSize: "12px", lineHeight: "15px", color: "#1e1e1e", borderBottom: "1px solid #eef2f5" }}>{item.gameId}</td>
                    <td style={{ textAlign: "right", fontSize: "12px", lineHeight: "15px", color: "#1e1e1e", borderBottom: "1px solid #eef2f5" }}>{item.name}</td>
                    <td style={{ textAlign: "right", fontSize: "12px", lineHeight: "15px", color: "#1e1e1e", borderBottom: "1px solid #eef2f5" }}>{item.marketId}</td>
                    <td style={{ textAlign: "right", fontSize: "12px", lineHeight: "15px", color: "#1e1e1e", borderBottom: "1px solid #eef2f5" }}>
                      {isOutright ? (
                        item.winner ? (
                          <span style={{ color: "#28a745" }}>
                            {item.winner}{" "}
                            <button
                              className="orange-btn"
                              style={{ padding: "2px 6px", fontSize: "10px", marginLeft: "5px" }}
                              onClick={() => openEditModal("winner", item)}
                            >
                              Edit
                            </button>
                          </span>
                        ) : (
                          <button className="orange-btn" onClick={() => openEditModal("winner", item)}>
                            Edit
                          </button>
                        )
                      ) : (
                        "--"
                      )}
                    </td>
                    <td style={{ textAlign: "right", fontSize: "12px", lineHeight: "15px", color: "#1e1e1e", borderBottom: "1px solid #eef2f5" }}>{moment(item.openDate).format("YYYY-MM-DD HH:mm:ss")}</td>
                    <td style={{ borderBottom: "1px solid #eef2f5" }}>
                      <div className="action-btn-group" style={{ justifyContent: "end" }}>
                        <button style={{
                          width: "120px",
                          boxShadow: "none",
                          backgroundColor: "rgb(255, 184, 12)",
                          color: "rgb(0, 0, 0)",
                          border: "1px solid #000",
                          paddingLeft: 0,
                          paddingRight: 0,
                          fontSize: "11px",
                          lineHeight: "23px",
                          height: "fit-content",
                          padding: "0px",
                          fontWeight: "bold",
                          borderRadius: "4px"
                        }} className="orange-btn" onClick={() => openEditModal("limit", item)}>
                          Set Limit
                        </button>
                        <button style={{
                          width: "120px",
                          boxShadow: "none",
                          backgroundColor: "rgb(255, 184, 12)",
                          color: "rgb(0, 0, 0)",
                          border: "1px solid #000",
                          paddingLeft: 0,
                          paddingRight: 0,
                          fontSize: "11px",
                          lineHeight: "23px",
                          height: "fit-content",
                          padding: "0px",
                          fontWeight: "bold",
                          borderRadius: "4px"
                        }} className="orange-btn" onClick={() => openEditModal("bookmaker", item)}>
                          Set Bookmaker
                        </button>
                        <button style={{
                          width: "120px",
                          boxShadow: "none",
                          backgroundColor: "rgb(255, 184, 12)",
                          color: "rgb(0, 0, 0)",
                          border: "1px solid #000",
                          paddingLeft: 0,
                          paddingRight: 0,
                          fontSize: "11px",
                          lineHeight: "23px",
                          height: "fit-content",
                          padding: "0px",
                          fontWeight: "bold",
                          borderRadius: "4px"
                        }} className="orange-btn" onClick={() => openEditModal("manipulation", item)}>
                          Manuplation
                        </button>
                        <button style={{
                          width: "120px",
                          boxShadow: "none",
                          backgroundColor: "rgb(255, 184, 12)",
                          color: "rgb(0, 0, 0)",
                          border: "1px solid #000",
                          paddingLeft: 0,
                          paddingRight: 0,
                          fontSize: "11px",
                          lineHeight: "23px",
                          height: "fit-content",
                          padding: "0px",
                          fontWeight: "bold",
                          borderRadius: "4px"
                        }} className="orange-btn" onClick={() => openEditModal("scw", item)}>
                          S.C.W
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={7} style={{ textAlign: "center", padding: "30px", fontWeight: "bold" }}>
                  No Record Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      )}

      {/* Popups */}
      {activeModal && selectedItem && (
        <SkyPopup
          title={getModalTitle()}
          OpenModal={!!activeModal}
          closeModel={() => {
            setActiveModal(null);
            setSelectedItem(null);
          }}
          submit={handleModalSubmit}
          closebtn={true}
          customClass="declare-result-popup"
          isLoading={isLoader}
        >
          {/* Winner Declaration Modal */}
          {activeModal === "winner" && (
            <div style={{ padding: "20px" }}>
              <div className="form-group-limit">
                <label>Select Outright Winner Selection Name:</label>
                <select
                  style={{ width: "100%", height: "35px", borderRadius: "4px", padding: "5px" }}
                  value={winner}
                  onChange={(e) => setWinner(e.target.value)}
                >
                  <option value="">-- Choose Winner --</option>
                  <option value="cancel">No Result (Cancel)</option>
                  {winnerOptions.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* Set Odds Limit Modal */}
          {activeModal === "limit" && (
            <div style={{ padding: "20px" }}>
              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", fontWeight: "bold" }}>Odds Rate Limits (OddsLimit)</h6>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Min Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      value={oddsLimit.min}
                      onChange={(e) => setOddsLimit({ ...oddsLimit, min: parseFloat(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Max Rate</label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      value={oddsLimit.max}
                      onChange={(e) => setOddsLimit({ ...oddsLimit, max: parseFloat(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>

              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", marginTop: "20px", fontWeight: "bold" }}>Bet Stake limits (Bet Odds Limit)</h6>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Min Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betOddsLimit.min}
                      onChange={(e) => setBetOddsLimit({ ...betOddsLimit, min: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Max Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betOddsLimit.max}
                      onChange={(e) => setBetOddsLimit({ ...betOddsLimit, max: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Max Profit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betOddsLimit.maxProfit}
                      onChange={(e) => setBetOddsLimit({ ...betOddsLimit, maxProfit: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Bet Delay (seconds)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betOddsLimit.betDelay}
                      onChange={(e) => setBetOddsLimit({ ...betOddsLimit, betDelay: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Set Bookmaker Limit Modal */}
          {activeModal === "bookmaker" && (
            <div style={{ padding: "20px" }}>
              <div className="checkbox-group-manipulation" style={{ marginBottom: "15px" }}>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={bookmakerActive}
                    onChange={(e) => setBookmakerActive(e.target.checked)}
                  />
                  Bookmaker Active
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={bookmakerSuspend}
                    onChange={(e) => setBookmakerSuspend(e.target.checked)}
                  />
                  Bookmaker Suspended
                </label>
              </div>
              {bookmakerSuspend && (
                <p style={{ color: "#dc143c", fontSize: "12px", marginBottom: "10px" }}>
                  Bookmaker suspend will cancel unsettled bookmaker bets and return the stake to players.
                </p>
              )}

              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", fontWeight: "bold" }}>Bookmaker Stake Limits</h6>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Min Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betBookmakerLimit.min}
                      onChange={(e) => setBetBookmakerLimit({ ...betBookmakerLimit, min: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Max Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betBookmakerLimit.max}
                      onChange={(e) => setBetBookmakerLimit({ ...betBookmakerLimit, max: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Max Profit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betBookmakerLimit.maxProfit}
                      onChange={(e) => setBetBookmakerLimit({ ...betBookmakerLimit, maxProfit: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Bet Delay (seconds)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betBookmakerLimit.betDelay}
                      onChange={(e) => setBetBookmakerLimit({ ...betBookmakerLimit, betDelay: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Manipulation Status Switches Modal */}
          {activeModal === "manipulation" && (
            <div style={{ padding: "20px" }}>
              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", fontWeight: "bold" }}>Active Status Switches</h6>
              <div className="checkbox-group-manipulation">
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={activeStatus.status}
                    onChange={(e) => setActiveStatus({ ...activeStatus, status: e.target.checked })}
                  />
                  Match Active
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={activeStatus.bookmaker}
                    onChange={(e) => setActiveStatus({ ...activeStatus, bookmaker: e.target.checked })}
                  />
                  Bookmaker Active
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={activeStatus.fancy}
                    onChange={(e) => setActiveStatus({ ...activeStatus, fancy: e.target.checked })}
                  />
                  Fancy Active
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={activeStatus.premium}
                    onChange={(e) => setActiveStatus({ ...activeStatus, premium: e.target.checked })}
                  />
                  Premium Active
                </label>
              </div>

              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", marginTop: "20px", fontWeight: "bold" }}>Suspended Switches</h6>
              <p style={{ color: "#dc143c", fontSize: "12px", marginBottom: "10px" }}>
                Turning on a suspend switch cancels unsettled bets for that market and returns the stake to players.
              </p>
              <div className="checkbox-group-manipulation">
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={suspend.odds}
                    onChange={(e) => setSuspend({ ...suspend, odds: e.target.checked })}
                  />
                  Odds Suspended
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={suspend.bookmaker}
                    onChange={(e) => setSuspend({ ...suspend, bookmaker: e.target.checked })}
                  />
                  Bookmaker Suspended
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={suspend.fancy}
                    onChange={(e) => setSuspend({ ...suspend, fancy: e.target.checked })}
                  />
                  Fancy Suspended
                </label>
                <label className="form-check">
                  <input
                    type="checkbox"
                    checked={suspend.premium}
                    onChange={(e) => setSuspend({ ...suspend, premium: e.target.checked })}
                  />
                  Premium Suspended
                </label>
              </div>
            </div>
          )}

          {/* S.C.W (Session & Premium & Max Profit limits) Modal */}
          {activeModal === "scw" && (
            <div style={{ padding: "20px" }}>
              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", fontWeight: "bold" }}>Session (Fancy) Limit</h6>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Min Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betFancyLimit.min}
                      onChange={(e) => setBetFancyLimit({ ...betFancyLimit, min: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Max Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betFancyLimit.max}
                      onChange={(e) => setBetFancyLimit({ ...betFancyLimit, max: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Max Profit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betFancyLimit.maxProfit}
                      onChange={(e) => setBetFancyLimit({ ...betFancyLimit, maxProfit: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Bet Delay (seconds)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betFancyLimit.betDelay}
                      onChange={(e) => setBetFancyLimit({ ...betFancyLimit, betDelay: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>

              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", marginTop: "20px", fontWeight: "bold" }}>Premium Limit</h6>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Min Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betPremiumLimit.min}
                      onChange={(e) => setBetPremiumLimit({ ...betPremiumLimit, min: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Max Stake</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betPremiumLimit.max}
                      onChange={(e) => setBetPremiumLimit({ ...betPremiumLimit, max: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Max Profit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betPremiumLimit.maxProfit}
                      onChange={(e) => setBetPremiumLimit({ ...betPremiumLimit, maxProfit: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Bet Delay (seconds)</label>
                    <input
                      type="number"
                      className="form-control"
                      value={betPremiumLimit.betDelay}
                      onChange={(e) => setBetPremiumLimit({ ...betPremiumLimit, betDelay: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>

              <h6 style={{ borderBottom: "1px solid #ddd", paddingBottom: "5px", marginBottom: "10px", marginTop: "20px", fontWeight: "bold" }}>Max Profit Limits (Game level)</h6>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Odds Profit Limit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={maxProfitLimit.odds}
                      onChange={(e) => setMaxProfitLimit({ ...maxProfitLimit, odds: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Bookmaker Profit Limit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={maxProfitLimit.bookmaker}
                      onChange={(e) => setMaxProfitLimit({ ...maxProfitLimit, bookmaker: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group-limit">
                <div className="row-inputs">
                  <div>
                    <label>Fancy Profit Limit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={maxProfitLimit.fancy}
                      onChange={(e) => setMaxProfitLimit({ ...maxProfitLimit, fancy: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                  <div>
                    <label>Premium Profit Limit</label>
                    <input
                      type="number"
                      className="form-control"
                      value={maxProfitLimit.premium}
                      onChange={(e) => setMaxProfitLimit({ ...maxProfitLimit, premium: parseInt(e.target.value) || 0 })}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </SkyPopup>
      )}
    </div>
  );
}

export default SportsSettings;
